import { Row } from 'src/components/atoms/Row';
import styled, { css } from 'styled-components';

export const PdfViewerWrapper = styled(Row.Col)`
  div {
    border: 11px solid ${({ theme }) => theme.color.blue[200]};
  }
`;

export const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;

  @media ${({ theme }) => theme.device.mobile} {
    padding: 1.5rem;
  }

  .income-verification-tooltip {
    padding-left: 10px;
  }

  .income-verification-date-picker {
    width: 100%;
  }

  & .raise {
    z-index: 9999999;
    position: relative;
  }
`;

export const CarouselMismatchBanner = styled.div<{ severity: 'warning' | 'error' }>`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  line-height: 1.4;

  ${({ severity }) =>
    severity === 'error' &&
    css`
      background: ${({ theme }) => theme.color.red[100]};
      border: 1px solid ${({ theme }) => theme.color.red[600]};
      color: ${({ theme }) => theme.color.red[700]};
    `}

  ${({ severity }) =>
    severity === 'warning' &&
    css`
      background: ${({ theme }) => theme.color.yellow[100]};
      border: 1px solid ${({ theme }) => theme.color.yellow[700]};
      color: ${({ theme }) => theme.color.yellow[500]};
    `}
`;

export const CarouselIncludeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 1rem;

  label {
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
  }
`;

export const NameComparison = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-size: 0.8rem;
  font-weight: 600;
`;
